<template>
  <!-- 用户管理-交易链接封禁-添加封禁链接弹窗 -->
  <div>
    <el-dialog :visible.sync="dialogVisible" :close-on-click-modal="false" title="添加封禁链接" width="350px"
      @close="closeDialog">
      <el-form :model="formData" v-if="formData" ref="formData" label-width="80px" size="small" :rules="taskRules">
        <el-form-item prop="type" label="封禁类型">
          <el-select v-model="formData.type" placeholder="请选择链接状态">
            <el-option :value="1" label="交易链接"></el-option>
            <el-option :value="2" label="用户id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="link" label="交易链接" v-if="formData.type === 1">
          <el-input v-model="formData.link" placeholder="请输入交易链接"></el-input>
        </el-form-item>
        <el-form-item prop="link" label="用户id" v-else>
          <el-input v-model="formData.link" placeholder="请输入用户id"></el-input>
        </el-form-item>
        <el-form-item prop="status" label="链接状态">
          <el-select v-model="formData.status" placeholder="请选择链接状态">
            <el-option :value="2" label="封禁7天"></el-option>
            <el-option :value="4" label="封禁到月底"></el-option>
            <el-option :value="3" label="封禁永久"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="remark" label="备注">
          <el-input type="textarea" maxlength="50" :rows="4" show-word-limit v-model="formData.remark"
            placeholder="请输入封禁备注">
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="closeDialog">取消</el-button>
          <el-button type="primary" @click="submit" :loading="buttonLoading">确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import { patchData, postData, getApiData, patchApiData, postApiData, delApiData } from '@/http'
export default {
  props: {
    visible: {//展示标志
      type: Boolean,
      default: false
    },
    value: {//数据
      type: Object,
      default: undefined
    },
    typeDialog: {//弹窗类型
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      loading: false,//加载动画
      buttonLoading: false,//按钮加载动画
      formData: {//表单数据
        type: 1,//封禁类型 1是交易链接 2是用户id 默认是1
        link: undefined,//交易链接
        status: 2,//链接状态 2是封禁7天 3的封禁永久
        remark: '',//备注
      },
      taskRules: {//添加表单验证
        type: [
          {
            required: true,
            message: '请选择封禁类型',
            trigger: 'blur'
          }
        ],
        link: [
          {
            required: true,
            message: '请输入正确的值',
            trigger: 'blur'
          }
        ],
        status: [
          {
            required: true,
            message: '请选择链接状态',
            trigger: 'blur'
          }
        ],
      }
    }
  },
  computed: {
    ...mapState({
    }),
    dialogVisible: {
      get() {
        return this.visible
      },
      set() {
      }
    },
    dialogInfo: {
      get() {
        return this.value
      },
      set() {
      }
    },
  },
  watch: {
  },
  created() {
  },
  methods: {
    submit() {
      //保存
      //表单验证后发起请求
      this.$refs['formData'].validate((valid) => {
        if (valid) {
          this.buttonLoading = true
          let params = this.formData
          postApiData('trade_link_banned', params).then(res => {
            if (res.code === 0) {
              this.$message.success(res.message)
              this.closeDialog()//关闭弹窗
              this.$emit("refresh")//刷新数据
            } else {
              this.$message.error(res.message)
            }
          }).finally(() => {
            this.buttonLoading = false
          })
        }
      })
    },
    closeDialog() {
      //关闭弹窗
      this.$emit("close")
    }
  }

}
</script>
<style lang="less" scoped>

</style>